import { ApplicationState, SdkState } from "@idw-types/state";
import { createSelector } from "reselect";

export const getSdkState = (state: ApplicationState): SdkState => {
    return state.sdk;
};

export const getSdkStateSelector = createSelector(getSdkState, (sdkState: SdkState) => {
    return sdkState;
});